/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
  Store,
  UnknownAction,
} from "redux";
import rootReducer, { RootState } from "./rootReducer";
import createSagaMiddleware, { SagaMiddleware } from "redux-saga";
import { persistStore, persistReducer, PersistConfig } from "redux-persist";
import storage from "redux-persist/lib/storage";
import SagaManager from "./sagas/sagaManager";

// Persist configuration
const persistConfig: PersistConfig<RootState> = {
  key: "root",
  storage,
  // You might want to specify which parts of your state you want to persist
  whitelist: ["languageVariable", "login", "localStorageReducer"],
  // blacklist: [],
};
const isDev = process.env.CURRENT_ENV==="local"
const devToolsOptions = {
  trace: isDev,
  traceLimit: 25, // Adjust this number to see more or less of the call stack
};

const composeEnhancers =
  (typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__(devToolsOptions)
    : compose;

// const composeEnhancers =
//   (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

declare const module: any;

const configureStore = () => {
  const sagaMiddleware: SagaMiddleware = createSagaMiddleware();
  const mainReducer: any = rootReducer;
  const persistedReducer = persistReducer(persistConfig, mainReducer);

  // Create store with the persisted reducer
  const store: Store<RootState, UnknownAction> = createStore(
    persistedReducer,
    composeEnhancers(applyMiddleware(sagaMiddleware as any))
  );

  // Enhance store with persist capabilities
  const persistor = persistStore(store);

  if (typeof module !== "undefined" && module.exports) {
    module.hot.accept("./rootReducer", () => {
      store.replaceReducer(module.default);
    });
    module.hot.accept("./sagas/sagaManager", () => {
      SagaManager.cancelSagas(store);
      SagaManager.startSagas(sagaMiddleware);
    });
  }

  SagaManager.startSagas(sagaMiddleware);

  return { store, persistor };
};

export default configureStore;
